import React, { useState } from "react";
import { Button, Menu, Text } from "@fragments";
import { STUDIO_FORMATS, formatAvailable } from "../../../../enums/formats";
import "../ComposerSuggestions/styles.scss";

export default function FormatSelector({
  studio: s,
  initial = false,
  compact = false,
}) {
  const { t, entry, current, formatLocked, updateEntry, capabilities } = s;
  const [open, setOpen] = useState(false);
  const locked = compact || formatLocked || !!current;
  const available = (format) => formatAvailable(format, capabilities);
  const selected = STUDIO_FORMATS.find(
    (format) => format.id === (current?.brief?.format || entry.format),
  );
  const select = (format) => {
    if (!locked && available(format))
      updateEntry({ format: format.id, formatSelected: true });
  };

  if (initial)
    return (
      <div className="studio-topics-preview">
        <div className="studio-composer__heading">
          <Text.caption contrast={6}>{t("formatQuestion")}</Text.caption>
        </div>
        <div
          className="studio-topic-chips"
          role="group"
          aria-label={t("formatQuestion")}
        >
          {STUDIO_FORMATS.map((format) => (
            <Button
              key={format.id}
              disabled={locked || !available(format)}
              color="overlay"
              variant="rounded"
              size="small"
              startIcon={<format.icon />}
              tooltip={!available(format) ? t("soon") : undefined}
              onClick={() => select(format)}
            >
              {t(format.labelKey)}
            </Button>
          ))}
        </div>
      </div>
    );

  if (!selected) return null;
  // An art shows the ratio it was made in (on the home the ratio has its own control).
  const ratio = selected.art ? current?.brief?.art?.aspect_ratio || null : selected.ratio;
  const label = `${t(selected.labelKey)}${ratio ? ` · ${ratio}` : ""}`;
  const trigger = (
    <Button
      className="studio-format-selector studio-plain-control"
      disabled={locked}
      color="overlay"
      variant="rounded"
      size="small"
      startIcon={<selected.icon />}
      dropdown={!locked}
      aria-haspopup={locked ? undefined : "menu"}
      aria-expanded={locked ? undefined : open}
    >
      {label}
    </Button>
  );
  if (locked) return trigger;

  return (
    <Menu
      placement="top-start"
      onOpenChange={setOpen}
      items={STUDIO_FORMATS.map((format) => ({
        id: format.id,
        label: t(format.labelKey),
        icon: <format.icon />,
        active: format.id === selected.id,
        disabled: !available(format),
        right: !available(format) ? (
          <Text.caption contrast={5}>{t("soon")}</Text.caption>
        ) : undefined,
        onClick: () => select(format),
      }))}
    >
      {trigger}
    </Menu>
  );
}
